<template>
  <div class="form-layout">
    <div class="header">
      <div class="title">
        <slot name="title" />
      </div>
      <div
        class="close-icon"
        @click="$store.commit('resetCreateEditComponentParams')"
      >
        <i class="fal fa-times text-3xl text-red cursor-pointer" />
      </div>
    </div>
    <div class="body">
      <slot name="body" />
    </div>
    <div class="footer">
      <bdg-button
        class="ghost no-min-width w-full mb-3 md:w-1/2 md:mb-0 md:mr-3 uppercase"
        @click.native="$store.commit('resetCreateEditComponentParams')"
      >
        cancel
      </bdg-button>

      <bdg-button
        class="no-min-width w-full md:w-1/2 uppercase"
        @click.native="$emit('save')"
        :is-loading="loading"
      >
        save
        {{ entityName ? ` ${entityName}` : "" }}
      </bdg-button>
    </div>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";

export default {
  name: "FormLayout",
  components: { BdgButton },
  props: {
    entityName: {
      type: String,
      default: null
    },
    loading: Boolean
  }
};
</script>

<style lang="scss" scoped>
.form-layout {
  @apply flex flex-col justify-between items-center w-full;

  .header {
    @apply flex justify-between w-full mb-4;

    @screen md {
      @apply relative;
    }

    .close-icon {
      @screen md {
        @apply absolute top-0 left-1 ml-2;
      }
    }
  }

  .body {
    @apply w-full mb-8;
  }

  .footer {
    @apply w-full;

    @screen md {
      @apply flex;
    }
  }
}
</style>
